import React, { Component } from 'react';

import Regulations from '../regulations';
import decl from '../helpers/declension';

import { setCookie } from '../../../helpers/cookie';

import base64EncodeUnicode from '../helpers/base64EncodeUnicode';

export default class ChoicePayment extends Component {
  state = {
    selectedPayment: 'card',
    googlePayPaymentClient: null,
    dataPaymentMethods: this.props.dataPaymentMethods,
    applePayCanMakePayments: true,
  };

  componentDidMount() {
    const paymentsClient = this.getGooglePaymentsClient();
    this.setState({ getGooglePaymentsClient: paymentsClient });
    this.googlePayButton = this.addGooglePayButton();
    $('.scheme-popup').addClass('scheme-popup--timer');

    if (this.props.userPaymentMethods.includes('sbp')) {
      this.setState({selectedPayment : 'sbp'});
    }
  }

  componentWillUnmount() {
    $('.scheme-popup').removeClass('scheme-popup--timer');
  }

  googlePayButton = null;

  paymentsClient = null;

  baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
  };

  allowedCardNetworks = ['MASTERCARD', 'VISA'];

  allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];

  tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
      gateway: this.state.dataPaymentMethods.payment.provider, // платежный шлюз
      gatewayMerchantId: this.state.dataPaymentMethods.payment.methods.google
        .bank_merchant_id, // уникальный идентификатор продавца
    },
  };

  baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
      billingAddressRequired: false,
      allowedAuthMethods: this.allowedCardAuthMethods,
      allowedCardNetworks: this.allowedCardNetworks,
    },
  };

  cardPaymentMethod = Object.assign({}, this.baseCardPaymentMethod, {
    tokenizationSpecification: this.tokenizationSpecification,
  });

  getGoogleIsReadyToPayRequest() {
    return Object.assign({}, this.baseRequest, {
      allowedPaymentMethods: [this.baseCardPaymentMethod],
    });
  }

  getGooglePaymentDataRequest() {
    const paymentDataRequest = Object.assign({}, this.baseRequest);
    paymentDataRequest.allowedPaymentMethods = [this.cardPaymentMethod];
    paymentDataRequest.transactionInfo = this.getGoogleTransactionInfo();
    paymentDataRequest.merchantInfo = {
      merchantId: this.state.dataPaymentMethods.payment.methods.google
        .merchant_id,
      merchantName: window.location.host,
    };

    paymentDataRequest.callbackIntents = ['PAYMENT_AUTHORIZATION'];

    return paymentDataRequest;
  }

  getGooglePaymentsClient() {
    if (!this.paymentsClient) {
      this.paymentsClient = new google.payments.api.PaymentsClient({
        environment: this.state.dataPaymentMethods.payment.methods.google
          .environment, //'TEST' or 'PRODUCTION'
        paymentDataCallbacks: {
          onPaymentAuthorized: this.onPaymentAuthorized,
        },
      });
    }
    return this.paymentsClient;
  }

  transactionRejectFactory = (
    message = 'Неизвестная ошибка',
    intent = 'PAYMENT_AUTHORIZATION',
    reason = 'PAYMENT_DATA_INVALID',
  ) => ({
    transactionState: 'ERROR',
    error: {
      message,
      intent,
      reason,
    },
  });

  onPaymentAuthorized = paymentData =>
    new Promise(async (resolve, reject) => {
      try {
        const sendPaymentTokenResult = await this.processPayment(paymentData);
        if (sendPaymentTokenResult.status === 'success') {
          if (sendPaymentTokenResult.data.redirect_url) {
            window.location.href = sendPaymentTokenResult.data.redirect_url;
            return resolve({ transactionState: 'SUCCESS' });
          }
          const googleRedirectUrl = sendPaymentTokenResult.googleRedirectUrl;
          await fetch(googleRedirectUrl);
          window.postMessage('close', '*');
          resolve({ transactionState: 'SUCCESS' });
        } else {
          resolve(
            this.transactionRejectFactory(sendPaymentTokenResult.error.message),
          );
        }
      } catch (error) {
        reject(this.transactionRejectFactory());
      }
    });

  addGooglePayButton() {
    const paymentsClient = this.getGooglePaymentsClient();
    const button = paymentsClient.createButton({
      onClick: this.onGooglePaymentButtonClicked,
      // buttonColor: 'white',
      buttonType: 'short',
    });
    return (
      <div
        onClick={() => this.onGooglePaymentButtonClicked()}
        dangerouslySetInnerHTML={{ __html: button.innerHTML }}
      />
    );
  }

  getGoogleTransactionInfo() {
    const { amount, checkout } = this.props;
    return {
      countryCode: 'RU',
      currencyCode: 'RUB',
      totalPriceStatus: 'FINAL',
      totalPrice: (amount - checkout.bonusPay).toString(),
    };
  }

  prefetchGooglePaymentData() {
    const paymentDataRequest = this.getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = {
      totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
      currencyCode: 'RUB',
    };
    const paymentsClient = this.getGooglePaymentsClient();
    paymentsClient.prefetchPaymentData(paymentDataRequest);
  }

  onGooglePaymentButtonClicked() {
    const paymentDataRequest = this.getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = this.getGoogleTransactionInfo();

    const paymentsClient = this.getGooglePaymentsClient();
    paymentsClient.loadPaymentData(paymentDataRequest);
  }

  tokenDataFactory = (orderId, payMethod, paymentToken) => ({
    'order-id': orderId,
    'pay-method': payMethod,
    payment_features: {
      paymentToken: paymentToken,
    },
  });

  processPayment = paymentData =>
    new Promise((resolve, reject) => {
      setTimeout(async () => {
        const token = paymentData.paymentMethodData.tokenizationData.token;

        const paymentToken = base64EncodeUnicode(token);

        const tokenData = JSON.stringify(
          this.tokenDataFactory(
            this.props.orderId.toString(),
            'google-pay',
            paymentToken,
          ),
        );

        const headers = {
          method: 'POST',
          body: tokenData,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const route = '/local/php_interface/api/v2/payment/pay/';

        try {
          const response = await fetch(route, headers);
          const data = await response.json();
          resolve(data);
        } catch (error) {
          console.error(error);
          reject({});
        }
      }, 1000);
    });

  /**
   * соответствия оплаты
   * (для добавления оплаты нужно добавить её в листинг)
   */
  getPaymentElement = (elementName, elementType) =>
    ({
      sbp: {
        label: 'СБП',
        button: (
          <button className="btn btn--accent" onClick={this.buyTicketsSbp}>
            Купить билеты
          </button>
        ),
        order: 0,
      },
      card: {
        label: 'Оплата картой',
        button: (
          <button className="btn btn--accent" onClick={this.buyTicketsSber}>
            Купить билеты
          </button>
        ),
        order: 1,
      },
      pushkin_card: {
        label: 'Пушкинская карта',
        button: (
          <button className="btn btn--accent" onClick={this.buyPushkinCard}>
            Купить билеты
          </button>
        ),
        order: 1,
      },
      apple: {
        label: 'Apple Pay',
        button: (
          <div
            className="apple-pay-button apple-pay-button-white-with-line"
            onClick={() => this.buyTicketsApplePay()}
          ></div>
        ),
        order: 1,
      },
      google: {
        label: 'Google Pay',
        button: this.googlePayButton,
        order: 1,
      },
    }[elementName][elementType]);

  onChangedPayment = event =>
    this.setState({
      selectedPayment: event.target.value,
      applePayCanMakePayments: true,
    });

  createRadioButtons = paymentMethods =>
    paymentMethods.map(paymentMethod => (
      <div key={paymentMethod} className="radio" style={{order: this.getPaymentElement(paymentMethod, 'order')}}>
        <input
          id={paymentMethod}
          type="radio"
          value={paymentMethod}
          name="radio-group"
          checked={this.state.selectedPayment === paymentMethod}
          onChange={this.onChangedPayment}
        ></input>
        <label htmlFor={paymentMethod}>
          {this.getPaymentElement(paymentMethod, 'label')}
        </label>
      </div>
    ));

  buyTicketsSber = () => {
    const data = {
      'order-id': this.props.orderId,
      'pay-method': 'card',
    };
    const headers = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (process.env.NODE_ENV !== 'dev') headers.credentials = 'include';

    this.setState({
      loading: true,
    });

    const route = '/local/php_interface/api/v2/payment/pay/';

    // try to buy a ticket
    fetch(route, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          if (json.data.bonus_order) {
            this.setState({
              loading: false,
            });
          } else {
            if (json.data.redirect_url !== '') {
              // renderBankIframe(json.data.redirect_url);
              window.location.href = json.data.redirect_url;
              setCookie('UNPAID_ORDER', 'TRUE');
              setCookie('PAYMENT_LINK', json.data.redirect_url);
              setCookie('PAYMENT_METHOD', 'card');
              setCookie('userChooseInfo', 0, monthTimeout);
            }

            // close popup
            window.closePopupInterval = setTimeout(() => {
              if ($('#bank_iframe').length > 0) {
                window.postMessage('ticketTimeout', '*');
              }
            }, window.expire_date - Date.now());

            this.setState({
              loading: false,
            });
          }
        } else if (json.data.available || json.errors) {
          const err = json.errors;
          returnError([err]);
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  buyPushkinCard = () => {
    this.props.onPushkinPay();
  };

  buyTicketsApplePay = () => {
    // console.log('START APPLE PAY');
    const canMakePayments = window.ApplePaySession.canMakePayments();
    if (!canMakePayments) {
      this.setState({ applePayCanMakePayments: canMakePayments });
      return;
    }
    const { amount, orderId, checkout } = this.props;

    const applePaymentRequest = {
      total: {
        label: 'Оплата билетов',
        amount: amount - checkout.bonusPay,
      },
      countryCode: 'RU',
      currencyCode: 'RUB',
      supportedNetworks: ['masterCard', 'visa'],
      merchantCapabilities: ['supports3DS'],
    };

    const applePaySession = new ApplePaySession(1, applePaymentRequest);
    // console.log('Apple session', applePaySession);

    /**
     *
     * Событие, если плашку apple pay оплаты закрыл сам пользователь
     * applePaySession.oncancel = event => console.log('Exit');
     */
    // console.log('BEGIN APPLE', applePaySession);
    //init session
    applePaySession.begin();

    const sendPaymentToken = paymentToken =>
      new Promise((resolve, reject) => {
        const tokenData = {
          'order-id': orderId.toString(),
          'pay-method': 'apple-pay',
          payment_features: {
            paymentToken: paymentToken,
          },
        };

        // console.log('----tokenData', tokenData);
        const headers = {
          method: 'POST',
          body: JSON.stringify(tokenData),
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const route = '/local/php_interface/api/v2/payment/pay/';

        fetch(route, headers)
          .then(response => response.json())
          .then(sendPaymentTokenResult => {
            if (sendPaymentTokenResult.status === 'success') {
              const appleRedirectUrl = sendPaymentTokenResult.appleRedirectUrl;
              fetch(appleRedirectUrl).then(() =>
                window.postMessage('close', '*'),
              );
              // window.location.href = appleRedirectUrl;
              resolve(true);
            } else {
              reject(false);
            }
          })
          .catch(error => console.error(error));
      });

    // Merchant Validation
    applePaySession.onvalidatemerchant = event => {
      const applePayUrl = event.validationURL;
      // console.log('applePayUrl', applePayUrl);
      const merchantData = {
        'order-id': orderId,
        'apple-pay-address-url': applePayUrl,
      };

      const headers = {
        method: 'POST',
        body: JSON.stringify(merchantData),
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const route = '/local/php_interface/api/v2/payment/get_applepay_session/';

      /**
       * Далее мы делаем запрос на сервер оплаты и у нас есть 2 варианта развития событий
       *
       * 1) Промис резолвится и мы получаем данные об успешной валидации мерчанта,
       *    после чего заканчиваем сессию валидации
       * 2) Промис реджектится и мы получаем причину отказа в валидации,
       *    после чего отменяем сессию оплаты
       */
      fetch(route, headers)
        .then(result =>
          result.json().then(superResult => {
            applePaySession.completeMerchantValidation(superResult.data);
          }),
        )
        .catch(error => {
          applePaySession !== null && applePaySession.abort();
        });
    };

    applePaySession.onpaymentauthorized = event => {
      const paymentToken = base64EncodeUnicode(
        JSON.stringify(event.payment.token.paymentData),
      );
      sendPaymentToken(paymentToken).then(success =>
        success
          ? applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS)
          : applePaySession.completePayment(ApplePaySession.STATUS_FAILURE),
      );
    };

    applePaySession.oncancel = function(event) {
      // console.log(event);
    };
  };

  buyTicketsSbp = () => {
    this.props.onSbpPay();
  };

  render() {
    const { selectedPayment } = this.state;
    const { selected, checkout, amount } = this.props;

    const choosedTicketClasses = ['hint__tickets'];
    if (selected.length) choosedTicketClasses.push('hint__tickets--active');

    const choosedTicketText = selected.length
      ? `${selected.length} ${decl(selected.length, [
          'билет',
          'билета',
          'билетов',
        ])} за ${amount - checkout.bonusPay} руб.`
      : `Выберите места`;

    return (
      <div className="buy-checkout-side__container">
        {/* mobile version */}
        <div className="scheme-popup__top">
          <button
            className="scheme-popup__top-btn left"
            type="button"
            onClick={() => this.props.onBackClick()}
          >
            <svg
              className="icon--shev"
              width="10"
              height="15"
              viewBox="0 0 5 8"
            >
              <path d="M3.6 7.8c.2.1.4.2.6.2.4 0 .8-.4.8-.9 0-.2-.1-.4-.3-.6l-2.6-2.5 2.6-2.5c.2-.2.3-.4.3-.6 0-.5-.4-.9-.8-.9-.2 0-.4.1-.6.2l-3.3 3.1c-.3.3-.4.9 0 1.2l3.3 3.3z" />
            </svg>
          </button>
          <h4 className="heading heading--2">Оформление заказа</h4>
        </div>

        {/* desktop version */}
        <button
          onClick={() => this.props.onBackClick()}
          className="buy-checkout-side__back"
        >
          <svg width="8" height="5">
            <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-shev-down"></use>
          </svg>
          Назад
        </button>

        <h4 className="heading heading--2">Способ оплаты</h4>
        <form className="radio-button pays-methods-row">
          {this.createRadioButtons(this.props.userPaymentMethods)}
        </form>
        <p style={{color:"#e41a69", fontSize:"14px"}}>Оплата "Пушкинской картой" доступна при выборе не более 1 места</p>
        <p style={{color:"#e41a69", fontSize:"14px"}}>Списание бонусов недоступно при оплате "Пушкинской картой"</p>
        {!this.state.applePayCanMakePayments && (
          <div className="buy-checkout-side__warning">
            <p>
              Сейчас ваше устройство не поддерживает обработку платежей с
              помощью Apple Pay
            </p>
            <a
              href="https://support.apple.com/ru-ru/HT201239#safari"
              target="_blank"
            >
              Как оплачивать с помощью Apple Pay?
            </a>
          </div>
        )}
        <div className="checkout-result__wrapper">
          <button
            className={choosedTicketClasses.join(' ')}
            onClick={() => this.props.showTooltip()}
          >
            {choosedTicketText}
          </button>
          <div className="btn-pay">
            {this.getPaymentElement(selectedPayment, 'button')}
          </div>
        </div>
        <Regulations link={this.props.user.pd} />
      </div>
    );
  }
}
